import { ChannelEditorScreen } from "open-modules/zdf/component/channeleditor";
import { CLICK, INPUT } from "system/demo";
import { channelFullDemoData } from "./channeldemo.data";

export function adminEditChannelStorySets() {
    return [
        {
            label: 'Edit channel',
            instanceKey: channelFullDemoData.modulePublic.channel.all.channel0.key,
            structureKey: "channel",
            personaKey: 'a',
            serverCall: channelFullDemoData.serverCall,
            modulePublic: channelFullDemoData.modulePublic,
            sessionData: { channelMembers: channelFullDemoData.channelMembers },
            roles: ["Owner"],
            content: <ChannelEditorScreen />,
            stories: [
                {
                    label: 'Disable default channel', actions: [
                        CLICK("default-channel-toggle"),
                        CLICK("Save")
                    ]
                },
                {
                    label: 'Edit channel', actions: [
                        INPUT("image-url", "https://www.cbc.ca/favicon.ico"),
                        INPUT("channel-name", "CBC"),
                        CLICK("Save")
                    ]
                },
            ]
        },
    ]
}
